/* Font Awesome 按需注册。
 *
 * 新增图标时在这里加一行 import 并放进 icons 数组；
 * 忘记加会在界面上显示成空白方块，比多打 1.9 MB 的全量包更容易发现和修复。
 */

import {
  // 导航
  faGaugeHigh,
  faLayerGroup,
  faClipboardCheck,
  faCalculator,
  faShieldHalved,
  faListCheck,
  faServer,
  // 顶栏动作
  faPlay,
  faPause,
  faBan,
  faHand,
  // 总览 / 持仓
  faWallet,
  faChartLine,
  faChartArea,
  faGauge,
  faSignal,
  faTag,
  faClock,
  faScaleBalanced,
  faFileSignature,
  faCheck,
  // 盘前计划
  faArrowTrendDown,
  faArrowTrendUp,
  faCircleCheck,
  faCircleXmark,
  faUserCheck,
  faRotateLeft,
  // 测算
  faKeyboard,
  faSquareRootVariable,
  faFlagCheckered,
  faTableList,
  // 风控
  faDiagramProject,
  faLocationCrosshairs,
  faChevronRight,
  faUnlock,
  faSliders,
  faFloppyDisk,
  // 订单 / 系统
  faFileExport,
  faNetworkWired,
  faPlugCircleCheck,
  faHeartPulse,
  faFlask,
  faToggleOn,
  faToggleOff,
  faUserShield,
  // 诊断页
  faStethoscope,
  faArrowLeft,
  faTriangleExclamation,
  // 图表
  faMinus,
  faRotate,
  // 小字提示
  faCircleInfo,
  // 交易所切换
  faBuildingColumns,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

import { faBitcoin } from '@fortawesome/free-brands-svg-icons'

export const icons = [
  faGaugeHigh, faLayerGroup, faClipboardCheck, faCalculator, faShieldHalved,
  faListCheck, faServer,
  faPlay, faPause, faBan, faHand,
  faWallet, faChartLine, faChartArea, faGauge, faSignal, faTag, faClock,
  faStethoscope, faArrowLeft, faTriangleExclamation, faMinus, faRotate, faCircleInfo,
  faScaleBalanced, faFileSignature, faCheck,
  faArrowTrendDown, faArrowTrendUp, faCircleCheck, faCircleXmark,
  faUserCheck, faRotateLeft,
  faKeyboard, faSquareRootVariable, faFlagCheckered, faTableList,
  faDiagramProject, faLocationCrosshairs, faChevronRight, faUnlock,
  faSliders, faFloppyDisk,
  faFileExport, faNetworkWired, faPlugCircleCheck, faHeartPulse,
  faFlask, faToggleOn, faToggleOff, faUserShield,
  faBuildingColumns, faChevronDown,
  faBitcoin,
]
